module.exports = __webpack_public_path__ + "static/img/afternoon.010d61c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/afternoon.png
// module id = 8OKN
// module chunks = 1